import React from 'react';
import '../../css/ServiceCompanyStatus.css';
import help_icon from '../../assets/help_icon.png';
import pending from '../../assets/pending.png';
import verified from '../../assets/verified.png';

export const ServiceCompanyStatus = ({ status, showOwnButton, handleOwnClick }) => {
    const renderStatus = () => {
        switch (status) {
            case 'Internal Complete':
                return showOwnButton && (
                    <span className="service-provider-status">
                        <div className="service-company-status-dot-divider"/>
                        <span>Is this Your Business?</span>
                        <div className="tooltip">
                            <img
                                src={help_icon}
                                alt="Help Icon"
                                className="service-company-status-claim-icon"
                                onClick={handleOwnClick}
                            />
                            <div className="tooltiptext">We’ve heard great things about your service. Click here to claim your profile. It’s Free!</div>
                        </div>
                    </span>
                )
            case 'New':
                return <span className="service-provider-status"><img src={pending} alt="pending"
                                                                      className="service-provider-status-pending"/></span>;
            case 'Incomplete Data':
                return <span className="service-provider-status"><img src={pending} alt="pending"
                                                                      className="service-provider-status-pending"/></span>;
            case 'Claim Processing':
                return <span className="service-provider-status"><img src={pending} alt="pending" className="service-provider-status-pending" /></span>;
            case 'Pending':
                return <span className="service-provider-status"><img src={pending} alt="pending" className="service-provider-status-pending" /></span>;
            case 'Active/Verified':
                return <span className="service-provider-status"><img src={verified} alt="verified" className="service-provider-status-verified"/></span>;
            default:
                return null;
        }
    };

    return (
        <div className="service-provider-status-container">
            {renderStatus()}
        </div>
    );
};
